<div  
  class="app-scene-button"
  [ngClass]="{
    'app-scene-button--selected': selected,
    'app-scene-button--disabled': disabled,
    'app-scene-button--expandable': expandable
  }">

  <div class="app-scene-button__container">
    <ng-content></ng-content>
  </div>
</div>